import React, { useEffect, useState } from 'react'
import { store } from '../../../../redux/store';
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio, Switch, Avatar, Col, Divider, Drawer, List, Row } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../../generalComponent/search';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './index.css'
import moment from 'moment';
//引入axios 进行服务器接口请求
import axios from "axios";
const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);
export default function OrderHistory() {
  const [dataSource, setDataSource] = useState([]);
  const [orderInfoJson, setOrderInfoJson] = useState();
  const [orderInfoData, setOrderInfoData] = useState([]);
  const [open, setOpen] = useState(false);
  const showDrawer = (id) => {
    //取值
    setOrderInfoData(JSON.parse(orderInfoJson)[id]);
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('orderId');//订单主id
  useEffect(() => {
    queryOrderHistoryList();
  }, [orderInfoData, orderInfoJson]); // 空数组确保只在挂载时设置观察者
  //返回上一层
  function backOrderList() {
    navigate("/main/inventory")
  }
  const token = store.getState().uData.token;
  function queryOrderHistoryList() {
    //请求后台接口
    // / 设置全局的Authorization头
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/order/orderHistoryList',
      params,
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data.orderList);
          setOrderInfoJson(JSON.stringify(response.data.data.orderInfoMap));
        } else {
          setDataSource({});
          setOrderInfoJson({});
        }
      },
      error => {
        navigate("/error");
      }
    )
  }

  const columns = [
    {
      title: '客户名称',
      dataIndex: 'customerName',
      key: 'customerName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '订单类别',
      dataIndex: 'mode',
      key: 'mode',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <span>{record.mode === 1 ? "销售" : "采购"}</span>
      )
    },
    {
      title: '支付状态',
      dataIndex: 'payStatus',
      key: 'payStatus',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => {
        let name = "";
        switch (record.payStatus) {
          case 1:
            name = "全支付";
            break;
          case 2:
            name = "赊欠";
            break;
          case 3:
            name = "部分支付";
            break;
        }
        return <span>{name}</span>;
      }
    },
    {
      title: '开单时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      sorter: (a, b) => moment(a.createTime).diff(moment(b.createTime)),
      defaultSortOrder: 'ascend',
      responsive: ['lg'],
      render: (val) => moment(val).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: '订单状态',
      dataIndex: 'valid',
      key: 'valid',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <span style={record.valid === 2 ? { color: '#FF0000' } : { color: '#68cf4f' }}>{record.valid === 1 ? "有效" : "废单"}</span>
      )
    },


    {
      title: '订单总金额',
      dataIndex: 'allMoney',
      key: 'allMoney',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '支付宝已支付金额',
      dataIndex: 'aliPayPrice',
      key: 'aliPayPrice',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '微信已支付金额',
      dataIndex: 'weChatPayPrice',
      key: 'weChatPayPrice',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '现金已支付金额',
      dataIndex: 'cashPayPrice',
      key: 'cashPayPrice',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '银行转账已支付金额',
      dataIndex: 'bankPayPrice',
      key: 'bankPayPrice',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '优惠金额（抹零）',
      dataIndex: 'discountPrice',
      key: 'discountPrice',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '剩余未支付金额',
      dataIndex: 'balance',
      key: 'balance',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <div>
          <a onClick={() => showDrawer(record.id)} style={{ marginRight: '20px' }}>查看详情</a>
        </div>
      )
    },
  ];
  return (
    <React.Fragment>
      <div className='back_order_list'>
        <div className='back_title' onClick={() => backOrderList()}>&lt;返回上一层</div>
        <div className="item-location">
          当前所在位置 : 订单操作历史信息页
        </div>
      </div>
      <div className="data-div">
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage:'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>
      <Drawer width={640} placement="right" title={`当前订单的详细内容`} onClose={onClose} open={open}>
        {
          orderInfoData.map((item, index) => (
            <div>
              <Row>
                <Col span={24}>
                  <span>模式:</span>
                  <span style={item.type == '1' ? {color: '#68cf4f'} : { color: '#e6122eff' }}>{item.type == '1' ? '散装' : '整装'}</span>
                </Col>

                <div style={item.type == '1' ? {} : { "display": "none" }}>
                  <Col span={24}>
                    <span>是否刨皮:</span>
                    {item.peel == '1' ? '是' : '否'}
                  </Col>
                  <Col span={24}>
                    <span>毛重:</span>
                    {item.totalWeight}
                  </Col>
                  <Col span={24}>
                    <span>均重:</span>
                    {item.averageWeight}
                  </Col>
                </div>

                <Col span={24}>
                  <span>货品名称:</span>
                  {item.goodName}
                </Col>
                <Col span={24}>
                  <span>包装形式:</span>
                  {item.packName}
                </Col>
                <Col span={24}>
                  <span>是否回收:</span>
                  {item.recycle == '1' ? '是' : '否'}
                </Col>
                <Col span={24}>
                  <span>单价:</span>
                  {item.price}
                </Col>
                <Col span={24}>
                  <span>数量:</span>
                  {item.num}
                </Col>
              </Row>
              <Divider />
            </div>
          ))
        }
      </Drawer>
    </React.Fragment>

  )
}
